import React, {PropTypes} from 'react';
import Card, { CardHeader } from '../core/Card'
import { HeartIcon } from '../core/icons'
import {cleanFirefoxDivs} from '../utils/AppHelper'

import { Progress, Icon, Row, Col, Modal } from 'antd';

import TextAppLink from './TextAppLink'



class Share extends React.Component {
  state = { visible: false }

  componentDidMount = () => {

  }

  showModal = () => {
    this.setState({
      visible: true,
    });
  }
  handleOk = (e) => {
    this.setState({
      visible: false,
    });
    cleanFirefoxDivs()
  }
  handleCancel = (e) => {
    this.setState({
      visible: false,
    });
    cleanFirefoxDivs()
  }
  render() {
    return (

      <Card onClick={this.showModal} style={{...this.props.style, cursor: "pointer"}}>
        <CardHeader title="Share" />
        <div className="Action">
          <HeartIcon/>
          <h3>Spread the Word</h3>
        </div>
        <Modal
          title="Spread the Word"
          visible={this.state.visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          footer={null}
          className="shareModal"
          >
            <TextAppLink label="Text the Everlance app directly to a friend!" buttonText="Send Now" onSubmit={this.handleOk}/>
          </Modal>
      </Card>


    );

  }
}

export default Share



// WEBPACK FOOTER //
// ./src/home/Share.jsx